const reducers = [
    'promo-message',
    'catalog',
    'compatibility-chooser',
    'content',
    'cookie',
    'daily-updates',
    'deck',
    'decks',
    'email-unsub',
    'hexagram',
    'horoscope',
    'karmacoin-store',
    'mail-lists',
    'mobile-nav-dropdown',
    'moon-phase',
    'nav-bar-mobile',
    'number',
    'oranum',
    'planet-tracker',
    'product',
    'product-message',
    'query-params',
    'recaptcha',
    'route',
    'tarot-reading',
    'tcod',
    'user',
    'zodiac',
].reduce(
    (reducerObject, reducerName) =>
        ({...reducerObject, [reducerName]: require(`./${reducerName}`)}),
    {}
);

const initialData = Object.keys(reducers).reduce(function (initial, reducerName) {
    const initialReducerInitial = reducers[reducerName].initial;
    const reducerInitial = typeof initialReducerInitial === 'undefined' ? null : initialReducerInitial;
    return {...initial, [reducerName]: reducerInitial};
}, {});

export function rootReducer(state, action) {
    if (!/:/.test(action.type)) {
        return {...initialData, ...state};
    }
    const [reducerName, methodName] = action.type.split(':');
    const reducerMethod = reducers[reducerName] && reducers[reducerName][methodName];
    const reducerState = state[reducerName] || initialData[reducerName];
    const newReducerState = reducerMethod ? reducerMethod(reducerState, action.payload, action.error) : reducerState;
    return {...state, [reducerName]: newReducerState};
}



// WEBPACK FOOTER //
// ./app/reducers/index.js